import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";
import Select from "Components/Admin/Form/Select";
import ResendValidationButton from "Components/Admin/ResendValidationButton";

import * as S from "./styles";

const SponsorForm = ({
  projectId,
  selectedSponsor,
  setSelectedSponsor,
  getProjectSponsors,
  statusOptions,
}) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    if (!selectedSponsor?.id) return;

    setSelectedStatus(
      statusOptions?.find(
        (sponsor) => sponsor.value === selectedSponsor.status_id,
      ),
    );
  }, [selectedSponsor]);

  const submit = async (data) => {
    setLoading(true);

    try {
      await api.post("/projects/update-project-sponsor", {
        ...data,
        sponsor_id: selectedSponsor?.id,
        status_id: selectedStatus?.value,
        project_id: projectId,
      });

      setLoading(false);

      showNotification(
        "success",
        "Sucesso!",
        "Patrocinador atualizado com sucesso!",
      );

      setSelectedSponsor(null);
      getProjectSponsors(projectId);
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      <S.Modal>
        <Form onSubmit={submit}>
          <S.Section>
            <span>Atualizar</span>
            <hr />
          </S.Section>

          <Select
            name="status_id"
            label="Status"
            options={statusOptions}
            placeholder="Selecione um Status"
            maxWidth="100%"
            value={selectedStatus}
            onChange={setSelectedStatus}
            required
          />

          {/* Só quando o pedido já foi enviado uma vez: em triagem, o caminho é
              mover o status para "Em validação". */}
          {selectedSponsor.validation_email_sent_at && (
            <S.Resend>
              <span>Pedido de validação</span>
              <ResendValidationButton
                sponsorId={selectedSponsor.id}
                sentAt={selectedSponsor.validation_email_sent_at}
              />
            </S.Resend>
          )}

          <span>
            Possui Interesse:{" "}
            <strong>
              {selectedSponsor.has_interest === true
                ? "Sim"
                : selectedSponsor.has_interest === false
                  ? "Não"
                  : "Não respondeu"}
            </strong>
          </span>

          <S.Buttons>
            <Button
              type="button"
              outline
              text="Fechar"
              disabled={loading}
              onClick={() => setSelectedSponsor(null)}
            />

            <Button type="submit" text="Atualizar" disabled={loading} />
          </S.Buttons>
        </Form>
      </S.Modal>
    </S.Wrapper>
  );
};

export default SponsorForm;
